import * as React from 'react';
import CheckboxMUI from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CheckCheckedIcon, CheckIcon } from './icons';
import css from './Checkbox.css';
const Checkbox = ({ className, label, checked, onChange }) => {
    return (React.createElement(FormControlLabel, { className: className, classes: {
            root: css.container,
            label: css.label
        }, control: React.createElement(CheckboxMUI, { classes: {
                root: css.checkbox,
                checked: css.checkbox_checked
            }, icon: CheckIcon, checkedIcon: CheckCheckedIcon, checked: checked, onChange: onChange }), label: label }));
};
export default Checkbox;
